
import React, { Component } from 'react';

export default class DLStockr extends Component {
    state = {
        value: 0,
      };
    render(){
        return(
            <div>
                    <h5>Learn</h5>
                    <br /> <br /> <br />
                Learning is important.
                <br /> <br />
                We learn from our clients, about them as business leaders and why they want
                and need the software they say as well as them as individuals to see
                and form better relationships. 
                <br /> <br />
                They have the winning ingredients to win, so we love when that magic brushes on to us too - 
                in short they inspire us too.
                <br /> <br />
                Also if we didn't study nor learn then we won't be here today offering world class software 
                and data building services - nor would we have even be able to create this website!<br />
                <br /> <br />
                So let's chat to get you exactly the software application or data system that you need.<br />
                Contact us today: admin@designlovesoftware.firebaseapp.com
            </div>
        );
    }
  }


// WEBPACK FOOTER //
// ./src/components/dlstockr.js